import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoadingService } from '../../core/services/loading.service';

@Component({
    selector: 'app-progress-bar',
    imports: [CommonModule],
    template: `
    @if (loadingService.isLoading()) {
      <div class="fixed top-0 left-0 right-0 h-px z-max pointer-events-none">
        <div 
          class="h-full bg-linear-to-r from-primary via-orange-500 to-primary shadow-[0_0_10px_rgba(255,107,0,0.5)] transition-all duration-300 ease-out"
          [style.width.%]="loadingService.progress()"
        ></div>
        <div class="absolute top-0 right-0 h-full w-24 bg-linear-to-r from-transparent to-white/20 blur-sm animate-pulse"></div>
      </div>
    }
  `
})
export class ProgressBarComponent {
    loadingService = inject(LoadingService);
}
